import type { ModelSchema } from '@ember-data/store/types';
import ApplicationSerializer from 'lumen/serializers/application';

export default class OccupancySerializer extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalize(
    typeClass: ModelSchema,
    hash: { extract_date: string; extract_date_utc?: string },
  ) {
    const rawExtractDate = hash.extract_date;

    // Clone extractDate to extractDateUtc so that we can use both the local time and UTC time
    if (rawExtractDate) {
      hash.extract_date_utc = rawExtractDate;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.normalize(typeClass, hash);
  }
}
